import { IInitalState } from "./interface";
import * as TYPES from "./type";

const initialState: IInitalState = {
  isCheckedAuth: false,
  user: null,
  loading: true,
  accessToken: "",
};

export const authReducer = (state: IInitalState, { type, payload }: any) => {
  state = state || initialState;
  switch (type) {
    case TYPES.INVALID_PAYLOAD:
      return {
        ...state,
        loading: true,
        error: payload,
      };
    case TYPES.AUTH_CURRENT_REQ:
      return {
        ...state,
        loading: true,
        user: null,
      };
    case TYPES.AUTH_CURRENT_SUCCESS:
      return { ...state, loading: false, isCheckedAuth: true, user: payload };
    case TYPES.AUTH_CURRENT_FAIL:
      return {
        ...state,
        loading: false,
        user: null,
      };
    case TYPES.AUTH_LOGIN_GOOGLE_REQ:
    case TYPES.AUTH_LOGIN_GOOGLE_FAIL:
      return {
        ...initialState,
        loading: true,
        isCheckedAuth: false,
      };
    case TYPES.AUTH_LOGIN_GOOGLE_SUCCESS:
      return { ...state, loading: false, isCheckedAuth: true, user: payload };
    case TYPES.AUTH_LOGOUT_GOOGLE_SUCCESS:
      return { ...initialState, loading: false, user: null };
    default:
      return state;
  }
};
